import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class SchedulingApi{
    static baseUrl = appConfig.gatewayUrl+appConfig.pdServicePath;
    // static baseUrl = "http://localhost:20065/pd-service" ;

    static QUERY_SCHEDULE_LIST = SchedulingApi.baseUrl+"/wb/pd-xj-shift/list";
    static QUERY_SCHEDULE_SHOP_LIST = SchedulingApi.baseUrl + "/wb/pd-xj-shift/shiftShop/list"
    static SAVE_SCHEDULE_SHOP = SchedulingApi.baseUrl + "/wb/pd-xj-shift/shiftShop/save"
    static DELETE_SCHEDULE_SHOP = SchedulingApi.baseUrl + "/wb/pd-xj-shift/shiftShop/delete"
    static LIST_SCHEDULE_PERSON = SchedulingApi.baseUrl + "/wb/pd-xj-shift/shiftPerson/list"
    static IMPORT_SCHEDULE_PERSON = SchedulingApi.baseUrl + "/wb/pd-xj-shift/shiftPerson/import"
    static COPY_SCHEDULE_PERSON = SchedulingApi.baseUrl + "/wb/pd-xj-shift/shiftPerson/copy"

    static list(params){
        return httpGet(SchedulingApi.QUERY_SCHEDULE_LIST,params);
    }

    static listShiftShop(param){
        return httpGet(SchedulingApi.QUERY_SCHEDULE_SHOP_LIST, param)
    }

    static saveShiftShop(param){
        return httpPut(SchedulingApi.SAVE_SCHEDULE_SHOP, param);
    }

    static deleteShiftShop(param){
        return httpPut(SchedulingApi.DELETE_SCHEDULE_SHOP, param);
    }

    static listShiftPerson(param){
        return httpGet(SchedulingApi.LIST_SCHEDULE_PERSON, param);
    }

    static importData(param, file){
        let formData = new FormData()
        formData.append('file', file);
        for(var key in param) {
            formData.append(key, param[key]);
        }
        return httpPost(SchedulingApi.IMPORT_SCHEDULE_PERSON,formData);

    }

    static copyShiftPerson(param){
        return httpPut(SchedulingApi.COPY_SCHEDULE_PERSON, param);
    }
}